var _rect, _path, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1050,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 1050,
    height: 700
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BF0A30",
    strokeWidth: 1330,
    strokeDasharray: 53.846,
    d: "M665,0v700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#002868",
    width: 383,
    height: 376.924
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "44.038,152.988 56.711,191.99 23.533,167.885 64.543,167.885 31.365,191.99 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.442,87.957 82.115,126.959 48.937,102.854 89.947,102.854 56.769,126.959 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.699,38.561 134.372,77.563 101.194,53.459 142.204,53.459 109.026,77.563 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.239,22.867 203.912,61.869 170.734,37.764 211.744,37.764 178.566,61.869 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.758,39.545 273.431,78.547 240.253,54.442 281.263,54.442 248.085,78.547 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.362,87.491 326.035,126.494 292.857,102.388 333.867,102.388 300.689,126.494 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.964,152.987 351.637,191.99 318.459,167.885 359.469,167.885 326.292,191.99 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.652,223.416 342.325,262.418 309.147,238.313 350.157,238.313 316.979,262.418 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.62,283.461 302.292,322.463 269.115,298.358 310.125,298.358 276.947,322.463 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.311,315.115 238.984,354.118 205.806,330.012 246.816,330.012 213.638,354.118 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.09,315.582 167.763,354.584 134.585,330.479 175.595,330.479 142.417,354.584 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.717,283.001 105.39,322.004 72.212,297.898 113.222,297.898 80.044,322.004 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.288,223.416 65.961,262.418 32.783,238.313 73.793,238.313 40.615,262.418 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.a46d8cfffb546c2247a4ce2749dca97e.svg";
export { ForwardRef as ReactComponent };